
import { computed, defineComponent, onBeforeMount, PropType, ref } from "vue";

import TravelService from "@/services/travel.service";

import FlightList from "@/components/Booking/Flights/FlightList.vue";
import FlightSorting from "@/components/Booking/Flights/FlightSorting.vue";
import EasyDrop from "@/components/EasyDrop.vue";
import FlightFilter from "@/components/Booking/Flights/FlightFilter.vue";
import DotSpinner from "@/components/EasySpinners/DotSpinner.vue";
import { useStore } from "vuex";
import {
  SearchBookingOverview,
  SearchFlightRecommendationResponse,
} from "@/types/models";
import IResponseData from "@/types/IResponseData";
import { LocaleStrings } from "@/types/paramModels";

export default defineComponent({
  components: {
    FlightList,
    FlightFilter,
    FlightSorting,
    EasyDrop,
    DotSpinner,
  },
  props: {
    bookingOverview: {
      type: Object as PropType<SearchBookingOverview>,
      required: true
    },
    searchQuery: {
      type: Object,
      required: true
    },
    pageTexts: {
      type: Object,
      required: true
    },
    localeStrings: {
      type: Object as PropType<LocaleStrings>,
      required: true
    }
  },
  setup(_props) {
    const store = useStore();
    const isPageLoading = ref(false);

    const hasErrorResponse = ref(false);
    const errorResponseMessage = ref(String);

    const query = computed(() => _props.searchQuery);

    const searchBookingOverview = computed(
      () =>
        store.getters[
        "TravelSearchBookingModule/getSearchTravelBookingOverview"
        ] as SearchBookingOverview
    );
    const flightRecommendations = computed(
      () =>
        store.getters[
        "TravelSearchBookingModule/getflightRecommendations"
        ] as SearchFlightRecommendationResponse
    );

    const selectedFlight = computed(
      () => _props.bookingOverview.flight
    );

    console.log(flightRecommendations);
    

    const pageIndex = computed(() => flightRecommendations?.value.paging?.pageNumber);

    const updateFilteredFlights = () => {
      store.dispatch("TravelSearchBookingModule/resetFlightRecommendationsPaging").then(() => {
        const filterRequest = {
          bookingSelection: flightRecommendations.value.bookingSelection,
          searchFilter: flightRecommendations.value.searchFilter,
          paging: flightRecommendations.value.paging,
          sorting: flightRecommendations.value.sorting,
        } as SearchFlightRecommendationResponse;

        TravelService.getFilterSearchTravelHotelFlights(filterRequest).then(
          (response: IResponseData<SearchFlightRecommendationResponse>) => {
            if (response.data.success) {
              hasErrorResponse.value = false;
              store
                .dispatch(
                  "TravelSearchBookingModule/updateFilteredFlights",
                  response.data.result
                )
                .then(() => {
                  isPageLoading.value = false;
                });
            } else {
              hasErrorResponse.value = true;
              errorResponseMessage.value = response.data.exception.message;
            }
          }
        );
      })
    }


    const addPage = () => {
      isPageLoading.value = true;
      store
        .dispatch("TravelSearchBookingModule/incrementFlightRecommendationsPaging")
        .then(() => {
          const filterRequest = {
            bookingSelection: flightRecommendations.value.bookingSelection,
            searchFilter: flightRecommendations.value.searchFilter,
            paging: flightRecommendations.value.paging,
            sorting: flightRecommendations.value.sorting,
          } as SearchFlightRecommendationResponse;

          TravelService.getFilterSearchTravelHotelFlights(filterRequest).then(
            (response: IResponseData<SearchFlightRecommendationResponse>) => {
              if (response.data.success) {
                hasErrorResponse.value = false;
                store
                  .dispatch(
                    "TravelSearchBookingModule/addFlightRecommendationsPage",
                    response.data.result.flights
                  )
                  .then(() => {
                    isPageLoading.value = false;
                  });
              } else {
                hasErrorResponse.value = true;
                errorResponseMessage.value = response.data.exception.message;
              }
            }
          );
        });
    };

    onBeforeMount(() => {
      if (!flightRecommendations.value || !flightRecommendations.value.flights?.length) {
        TravelService.getSearchTravelHotelFlights(
          searchBookingOverview.value.bookingSelection
        ).then((response: IResponseData<SearchFlightRecommendationResponse>) => {
          if (response.data.success) {
            hasErrorResponse.value = false;
            store.dispatch(
              "TravelSearchBookingModule/updateFlightRecommendations",
              response.data.result
            ).then(() => {
              isPageLoading.value = false;
            });
          } else {
            hasErrorResponse.value = true;
            errorResponseMessage.value = response.data.exception.message;
          }
        });
      }
    });

    return {
      hasErrorResponse,
      errorResponseMessage,
      query,
      pageIndex,
      flightRecommendations,
      addPage,
      updateFilteredFlights,
      isPageLoading,
      selectedFlight,
    };
  },
});
